import loadable from "loadable-components";

const CategoryPageRoute = loadable(() =>
  import(/* webpackPreload: true, webpackChunkName: "c" */ "../CategoryPage")
);

export default CategoryPageRoute;
